'use strict';

// @ts-ignore
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
import 'requestidlecallback-polyfill';

// Array.prototype.findLast — ES2023. Not available in Safari <15.4, Chrome <97, Firefox <104.
if (!Array.prototype.findLast) {
  Array.prototype.findLast = function (callback: any, thisArg: any) {
    if (typeof callback !== 'function') {
      throw new TypeError('callback must be a function');
    }

    const O = Object(this);
    const len = O.length >>> 0;

    for (let k = len - 1; k >= 0; k--) {
      if (k in O) {
        const kValue = O[k];
        if (callback.call(thisArg, kValue, k, O)) {
          return kValue;
        }
      }
    }
    return undefined; // If no element satisfies the condition
  };
}

// Object.hasOwn — ES2022. Not available in Safari <15.4, Chrome <93, Firefox <92.
// 16 call sites across the codebase rely on it; older Safari/WebKit throws
// "Object.hasOwn is not a function" and crashes the error boundary.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn
if (!Object.hasOwn) {
  Object.hasOwn = function hasOwn(obj: object, prop: PropertyKey): boolean {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}
